import { DIRECTOR_AUTOFILL_DETAIL_KEY } from "constants/filingFormFields";
import { Section } from "types/Models/Filing";

/**
 * Whether any director row has a director picked. Uses the field's
 * validation key, else the director autofill id every picked row carries.
 */
export const hasSelectedDirector = (
  section: Pick<Section, "repeatable_fields">,
  validationKey?: string
): boolean => {
  const detailKey = validationKey || DIRECTOR_AUTOFILL_DETAIL_KEY;

  return (section.repeatable_fields ?? []).some(
    ({ selected_autofill_details }) =>
      Object.entries(selected_autofill_details ?? {}).some(
        ([key, details]) => key === detailKey && Boolean(details)
      )
  );
};
